export var EColumnProperty;
(function (EColumnProperty) {
    EColumnProperty["Aggregation"] = "aggregation";
    EColumnProperty["AggregationLimit"] = "aggregationLimit";
    EColumnProperty["BusinessType"] = "businessType";
    EColumnProperty["Label"] = "label";
    EColumnProperty["Description"] = "description";
    EColumnProperty["HiddenByDefault"] = "hideDefault";
    EColumnProperty["Technical"] = "technical";
    EColumnProperty["Currency"] = "currency";
    EColumnProperty["PrecisionDigits"] = "format";
    EColumnProperty["Underlying"] = "underlying";
    EColumnProperty["Group"] = "group";
    EColumnProperty["AsOfDate"] = "asOfDate";
    EColumnProperty["CurrencyOrigin"] = "currencyOrigin";
    EColumnProperty["CurveColumn"] = "curveColumn";
    EColumnProperty["CurrencyColumn"] = "currencyColumn";
    EColumnProperty["SubstitutionColumn"] = "substitution";
})(EColumnProperty || (EColumnProperty = {}));
